import { styled } from '@mui/material/styles';

export const PlatformCell = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 12,
});

export const EmptyState = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    padding: '64px 24px',
    textAlign: 'center',
    color: 'var(--text-secondary)',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: 8,
});

export const SearchWrapper = styled('div')({
    padding: 16,
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
});

export const IntegrationList = styled('ul')({
    listStyle: 'none',
    margin: 0,
    padding: 0,
});

export const IntegrationRow = styled('li')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    padding: '12px 16px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
});

export const IntegrationRowLeft = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    minWidth: 0,
});

export const EmptyResults = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 8,
    padding: 24,
});

export const ChipRow = styled('div')({
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    marginTop: 8,
});
